// Initial state
const INITIAL_STATE = {
  isGameActive: false,
  isGameAnimating: false,
  startTime: new Date(),
  isEdgesActive: false,
  isPreviewActive: false
};

export { INITIAL_STATE };



// WEBPACK FOOTER //
// ./src/constants/index.js